module.exports = __webpack_public_path__ + "img/yun-zhu-logo.dc46ea31.jpg";